import React from 'react';

function AboutUs(props) {

    return (
        <div className="aboutUs">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h2 className="midTitles">About Us</h2>
                        <p className="quote d-none d-sm-block">“Learning how to be still,<br/> to really be still and let life
                            happen<br/>—that stillness becomes a radiance.”<br/>&#8212; Morgan Freeman</p>
                        <p>Goldenrod Cafe was founded in 2000 and has been loving and serving customers for decades. We
                            create a fresh and friendly environment that fosters productivity, creativity, and peace over
                            top notch, handcrafted food and beverages!</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;